/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['endpoints', 'rest/request/singleRequestServiceFactory', 'apiKeyNames'],
    function(endpoints, singleRequestServiceFactory, ApiKeyNames) {
        'use strict';

        return {
            incidentsDetails: singleRequestServiceFactory(endpoints.trafficIncidents, ApiKeyNames.traffic)
        };
    });



// WEBPACK FOOTER //
// ./rest/trafficIncidents.js